export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/lineDesktop.4cea5349.svg","height":16,"width":489,"blurWidth":0,"blurHeight":0};